// src/layouts/PortalLayout.js
import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ContentBlockerNotice from '../components/ContentBlockerNotice';
import { useAuth } from '../context/AuthContext';
import { isPosAdminRole } from '../constants/retailRoles';

import './PortalLayout.css';

function PortalLayout() {
  const { pathname } = useLocation();
  const { posRole } = useAuth();
  const isWideSales = pathname === '/ventas' && isPosAdminRole(posRole);

  return (
    <div className="layout-horizontal layout-wrapper">
      <Navbar />
      <div className={`content-wrapper ${isWideSales ? 'rg-layout-container rg-layout-container--2xl' : 'container-xxl'}`}>
        <ContentBlockerNotice />
        <Outlet />
      </div>
      <Footer />
    </div>
  );
}

export default PortalLayout;
